<template>
  <div id="app">
     <!-- Global notifications container -->
    <AppNotifications />
    <AppNavigation v-if="!isLoading" />
    <main v-if="!isLoading" class="main-content">
      <router-view />
    </main>
    <div id="app-loading" v-else>
      <div class="spinner"></div>
      <div class="loading-text">Loading...</div>
    </div>
  </div>
</template>

<script setup lang="ts">
import { onMounted, computed } from 'vue';
import { useStore } from './services/store.service';
import { useAuthService } from './services/auth.service';
import { setTitle } from './services/title.service';
import { useDeviceService } from './services/device.service';
import AppNavigation from './components/AppNavigation.vue';
import AppNotifications from './components/AppNotifications.vue';
import { useNotifications } from './services/notifications.service';

setTitle();
useDeviceService();
const store = useStore();
const authService = useAuthService();
const { showError } = useNotifications();

const isLoading = computed(() => !store.isAppReady());

onMounted(async () => {
  store.setAppReady(false);

  const configSuccess = await authService.config();
  if (!configSuccess) {
    console.error('Application Failed. Please try again later.');
    showError('Application Failed. Please try again later.', 99999);
    return;
  }

  await authService.user();
  store.setAppReady(true);
});
</script>

<style lang="css">
#app {
  display: flex;
  flex-direction: column;
}

.main-content {
  flex: 1;
  padding: 2rem;
  max-width: 1200px;
  margin: 0 auto;
  width: 100%;
}
#app-loading {
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  min-height: 100vh;
  animation: fadeIn 0.5s;
}

#app-loading .spinner {
  width: 40px;
  height: 40px;
  border: 4px solid var(--gray-200);
  border-top: 4px solid var(--primary-color);
  border-radius: 50%;
  animation: spin 1s linear infinite, fadeIn 1s;
  margin-bottom: 1rem;
}

#app-loading .loading-text {
  font-size: 1.2rem;
  color: var(--primary-color);
  letter-spacing: 0.1em;
  animation: fadeIn 1s;
}
</style>
